import { get } from '@lumapps/constants';
import { createPageRoute } from '@lumapps/router';

import { BKPR_ID } from './constants';

const { applicationId } = get();

export const beekeeperRedirectRoute = createPageRoute({
    appId: applicationId,
    slug: `${BKPR_ID}/*`,
});
